import React from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/packages/blue-book-player/library/button';

const UnAnsweredQuestion = (props) => {
  const { title, onClick } = props;
  return (
    <Button isLink isNaked onClick={onClick}>
      {title}
    </Button>
  );
};

UnAnsweredQuestion.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default UnAnsweredQuestion;
